module.exports = __webpack_public_path__ + "static/img/3.0f6177f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/zh/3.png
// module id = hVJf
// module chunks = 0